import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Navbar, NavDropdown } from 'react-bootstrap';

const TopBands = (props) => {
  const history = useHistory();
  const liStyle = {
    cursor: 'pointer',
  };
  return (

    <Navbar expand='lg' id='main-menu' sticky='top' variant='dark'>
      <div className='container'>
          <a className='navbar-brand' href='/'>
            <img src='images/coin-bazzar1.png' width='177px' height='45' />
          </a>
          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse>
            <ul className='navbar-nav ml-auto main-menu-cl'>
              <li
                className={`nav-item  ${props.page == 'Main' ? 'active' : ''}`}
                style={{ cursor: 'pointer', color: 'CEA538' }}
              >
                <a href='/' className='nav-link'>
                  Home
                </a>
              </li>
              <li
                className={`nav-item  ${props.page == 'sip' ? 'active' : ''}`}
                style={{ cursor: 'pointer', color: 'CEA538' }}
              >
                <a href='/sip' className='nav-link'>
                SIP
                </a>
              </li>
              <li
                className={`nav-item  ${props.page == 'multimetal-sip' ? 'active' : ''}`}
                style={{ cursor: 'pointer', color: 'CEA538' }}
              >
                <a href='/multimetal-sip' className='nav-link nav-link-badged'>
                Multimetal SIP
                <span className='nav-badge-new'>NEW</span>
                </a>
              </li>

                <li
                className={`nav-item  ${props.page == 'comingsoon' ? 'active' : ''}`}
                style={{ cursor: 'pointer', color: 'CEA538' }}
              >
                <a href='/redeem-coins-bars' className='nav-link'>
                Redeem eBullion Gold / Silver Bar
                </a>
              </li>
            
              {/* Buy Bullion on CoinBazaar — temporarily hidden, see Footer for Trustee Certificate / FAQs           */}
              <li
                className={`nav-item nav-link ${
                  props.page == 'delivery' ? 'active' : ''
                }`}
                onClick={() =>
                  window.open('https://www.coinbazaar.in/', '_blank')
                }
                style={{ cursor: 'pointer', color: 'CEA538' }}
              >
                Buy Bullion on CoinBazaar
              </li>
    
              {/* <li
                className={`nav-item  ${props.page == 'price-charts' ? 'active' : ''}`}
                style={{ cursor: 'pointer', color: 'CEA538' }}
              >
                <a href='/price-charts' className='nav-link'>
                  Price Charts
                </a>
              </li> */}
              <li
                className='nav-item'
                onClick={() =>
                  window.open('https://coinbazaar.ebullion.in/', '_blank')
                }
                style={{ cursor: 'pointer' }}
              >
                <span className='last-btn'>Sign In / Sign Up</span>
              </li>
            </ul>
          </Navbar.Collapse>
        </div>
    </Navbar>
    
  );
};

export default TopBands;
